import PropTypes from 'prop-types';
import FJConfig from '../../../config/FJConfig';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJAutoSelectionNoticeModal.module.less';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';
import FJConstant from '../../../constants/FJConstant';
const FJAutoSelectionNoticeModal = ({ onClose }) => {
    return (
        <div className={styles.container}>
            <video className={styles.preview} src={FJConfig.quickSelectionTipVideoUrl} autoPlay muted loop />
            <div className={styles.title}>{FJLocalStore._('auto-selection')}</div>
            <div className={styles.text}>
                {FJLocalStore._('please-click-to-select-the-object-to-remove-from-the-image')}
            </div>
            <FJIconButton
                className={styles.btn}
                type={FJConstant.GRADIENT}
                text={FJLocalStore._('got-it')}
                textClassName={styles.btn_text}
                onClick={onClose}
            />
        </div>
    );
};
FJAutoSelectionNoticeModal.propTypes = {
    onClose: PropTypes.func,
};
export default FJAutoSelectionNoticeModal;
